export default {
  data() {
    return {
      show: false,
      checkStatus: false,
      originHeight: 0
    };
  },
  watch: {
    checkStatus(flag) {
      if (flag) {
        this.show = true;
      }
      const tick = flag ? this.$nextTick : window.requestAnimationFrame;

      tick(() => {
        const { unfoldRef, wrapRef } = this.$refs;
        if (!unfoldRef || !wrapRef) {
          return;
        }

        const h = this.originHeight || unfoldRef.offsetHeight;
        if (h) {
          this.originHeight = h;
          const contentHeight = h + 'px';
          wrapRef.style.height = flag ? 0 : contentHeight;

          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              wrapRef.style.height = flag ? contentHeight : 0;
            });
          });
        }
      });
    }
  },
  methods: {
    resizeHeight() {
      this.checkStatus = !this.checkStatus;
      this.$emit('click', this.checkStatus);
    },
    onTransitionEnd() {
      if (!this.checkStatus) {
        this.show = false;
      } else {
        this.$refs.wrapRef.style.height = '';
      }
    }
  }
};
